import { calendarDays } from '@/mocks/calendar';

const dayOrder = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];

export default function CalendarGrid() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-7">
        {dayOrder.map((d) => {
          const day = calendarDays.find((x) => x.day === d);
          const isToday = d === '周五';
          return (
            <div
              key={d}
              className={`rounded-2xl border p-4 ${
                isToday ? 'border-primary-300 bg-primary-50' : 'border-background-200/70 bg-background-50'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="text-sm font-bold text-foreground-950">
                  {d}
                  {isToday && (
                    <span className="ml-2 rounded-full bg-primary-500 px-2 py-0.5 text-[10px] text-background-50">
                      今天
                    </span>
                  )}
                </span>
                <span className="text-xs text-foreground-500">{day?.date ?? '—'}</span>
              </div>

              <div className="mt-4 space-y-3">
                {day?.items.map((item) => (
                  <div key={item.title} className="rounded-xl bg-background-100 p-3">
                    <p className="text-sm font-semibold text-foreground-900">{item.title}</p>
                    <div className="mt-2 space-y-1 text-xs text-foreground-500">
                      <p className="flex items-center gap-1.5">
                        <i className="ri-book-2-line text-primary-500"></i>
                        {item.chapter}
                      </p>
                      <p className="flex items-center gap-1.5">
                        <i className="ri-price-tag-3-line text-accent-600"></i>
                        {item.category}
                      </p>
                      <p className="flex items-center gap-1.5">
                        <i className="ri-time-line"></i>
                        {item.time} 更新
                      </p>
                    </div>
                  </div>
                ))}
                {!day?.items.length && (
                  <p className="rounded-xl bg-background-100 px-3 py-6 text-center text-xs text-foreground-400">
                    今日暂无更新
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}